import { Button, Card, IconButton, Typography } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import momentz from 'moment-timezone';
import ReactGA from 'react-ga';
import CircularProgress from '@material-ui/core/CircularProgress';
import Refresh from '@material-ui/icons/Refresh';
import DownArrow from '@material-ui/icons/ArrowDropDown';
import UpArrow from '@material-ui/icons/ArrowDropUp';
import styles from './OptionsBoardStyles';
import { is_weekend } from '../../components/Modals/UOAModal/getDate';
import Calender from '../../components/Calender';
import SharkIcon from '../icons/shark.png';
import { setOptionChainAction } from '../../actions/optionChainAction';
import { setAppStateAction } from '../../actions/appStateAction';
import {
  fetchDataFunc,
  fetchHolderListFunc,
  fetchQuoteInfoFunc,
  getExpirationOptionsFunc,
  refreshDataAndExpirationsFunc,
} from '../../Shared';
import SelectedExpration from './SelectedExpration';
import SelectedExprationCard from './SelectedExprationCard';
import { useHistory } from 'react-router-dom';

let newDate = moment(new Date()).format('YYYY-MM-DD');

const MobileView = ({rows,changeBidAskMid}) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const { appReducer, optionChainReducer } = useSelector((state) => state);
  const {
    isMobile,
    width,
    quoteInfo,
    targetPrice,
    ticker,
    refreshingQuote,
    expiration,
    holderList,
    accessLevel,
    tickerChanged,
  } = appReducer;
  const { latestPrice, change, changePercent, symbol } = quoteInfo;

  const { selectedExpration, selectedDate, localTicker } = optionChainReducer;

  const setOptionChainState = (payload) =>
    dispatch(setOptionChainAction(payload));
  const setAppState = (payload) => dispatch(setAppStateAction(payload));

  const changeTicker = (event) => {
    const ticker = event.target.value.toUpperCase();
    setAppState({ ticker, tickerChanged: true });
  };

  const targetPriceChange = (value) => {
    if (value < 0) return;
    setAppState({ targetPrice: value });
    ReactGA.event({
      category: 'ChainAction',
      action: 'Changed target price',
      label: `${ticker} by ${targetPrice}`,
    });
  };

  const refreshDataAndExpirations = (ticker, date = '') => {
    setAppState({ errorMessages: [] });
    fetchQuoteInfoFunc(ticker, date, appReducer, setAppState);
    fetchHolderListFunc(ticker, setAppState);
    if (tickerChanged) {
      getExpirationOptionsFunc(ticker, date, appReducer, setAppState);
      setAppState({ confidence: 8, targetPrice: '' });
    } else {
      getExpirationOptionsFunc(ticker, date, appReducer, setAppState);
      fetchDataFunc(ticker, expiration, date, appReducer, setAppState);
    }

    ReactGA.event({
      category: 'ChainAction',
      action: 'Refreshed Data and Expirations',
      label: `${ticker}`,
    });
  };

  const isXSmall = width < 426;
  const priceChange = change;
  const priceChangePercent = changePercent;

  let lengthCheck = false;
  if (Object.keys(holderList).length > 0) {
    if (holderList.hieghestCalls.length || holderList.hieghestPuts.length) {
      lengthCheck = true;
    }
  }
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div style={isXSmall ? styles.topBarXs : styles.topBar}>
        <div
          style={
            isXSmall
              ? styles.dateSelectContainerXsmall
              : styles.dateSelectContainer
          }
        >
          <input
            name="ticker"
            style={styles.tickerInputMobile}
            value={ticker}
            placeholder="Stocks Ticker"
            onChange={(event) => changeTicker(event)}
          />
          <Button
            variant="contained"
            style={styles.goButtonMobile}
            onClick={() => {
              setOptionChainState({
                localTicker: ticker,
                selectedExpration: false,
              });
              targetPriceChange(0);
              let date = momentz
                .tz(new Date(), 'America/New_York')
                .format('YYYY-MM-DD');
              const newDate =
                accessLevel === 'fullaccess' ? is_weekend(date) : date;
              setOptionChainState({ modalDate: newDate });
              localStorage.setItem('Date', newDate);
              setOptionChainState({
                selectedDate: newDate,
              });
              refreshDataAndExpirationsFunc(
                ticker,
                newDate,
                appReducer,
                setAppState
              );
              history.push(`/optionschain/${ticker}`);
              window.scroll(0, 0);
            }}
          >
            Go
          </Button>
        </div>
        <div style={{ ...styles.calenderOB, margin: '0 10px' }}>
          <Calender
            accessLevel={accessLevel}
            value={selectedDate}
            disabled={localTicker === '' ? true : false}
            isMobile={isMobile}
            getDate={(e, event) => {
              refreshDataAndExpirations(ticker, e);
              const modalDate = e;
              setOptionChainState({
                selectedDate: e,
                isDateSelected: true,
                modalDate: modalDate,
              });
            }}
          />
        </div>
      </div>
      {selectedExpration && (
        <div style={styles.mobileTxExp}>
          Select a Target Stock Price & Confidence Level
        </div>
      )}

      <div style={styles.mobileTopDetail}>
        <div style={styles.headerInfoMobile}>
          <Card
            style={{
              ...styles.selectorsMobile,
              borderRight: '1px black solid',
              width: '45%',
            }}
          >
            {!symbol && (
              <Typography
                variant="inherit"
                component="h5"
                style={{ ...styles.noTickerText, fontSize: '0.75rem' }}
              >
                Enter a stock ticker to your left & click 'Gos'
              </Typography>
            )}
            {symbol && (
              <div>
                <Typography
                  variant="inherit"
                  component="h3"
                  style={{ ...styles.companyText, fontSize: '0.9rem' }}
                >
                  {/* {companyName && !isMobile ? companyName.substring(0, 12) : ''}{' '} */}
                  {!isMobile
                    ? `${symbol}`
                    : `${symbol} $${(latestPrice * 1).toFixed(2)}
                              `}
                </Typography>
                <div style={styles.stockPriceInfo}>
               
                    <span
                      style={
                        priceChange < 0
                          ? styles.negPriceChange
                          : styles.posPriceChange
                      }
                    >
                      {priceChange < 0 ? (
                        <DownArrow
                          style={
                            isMobile ? styles.downArrowMobile : styles.downArrow
                          }
                        />
                      ) : (
                        <UpArrow
                          style={
                            isMobile ? styles.upArrowMobile : styles.upArrow
                          }
                        />
                      )}{' '}
                      <span style={styles.priceChange}>
                        ${Math.abs(priceChange).toFixed(2)}
                      </span>
                      ({Math.abs(priceChangePercent).toFixed(2)}
                      %)
                    </span>
                 

                  {refreshingQuote ? (
                    <CircularProgress
                      style={styles.circularSpinner}
                      size={20}
                      color="primary"
                    />
                  ) : (
                    <IconButton
                      aria-label="Refresh"
                      disabled={refreshingQuote}
                      size="small"
                      color="primary"
                      style={styles.refreshButton}
                      onClick={() => refreshDataAndExpirations(ticker, selectedDate)}
                    >
                      <Refresh />
                    </IconButton>
                  )}
                </div>
                <div style={{ display: 'flex' }}>
                  <Typography
                    variant="body1"
                    component="div"
                    style={{ ...styles.timestampText, paddingTop: '2px' }}
                  >
                    As of{' '}
                    {moment(selectedDate).isBefore(newDate) ? (
                      <span style={{ marginLeft: '2px' }}>
                        {moment(selectedDate).format('MMM DD')} 4:00pm{' '}
                      </span>
                    ) : (
                      <span style={{ marginLeft: '2px' }}>
                        {moment(quoteInfo.latestUpdate).format('MMM DD h:mma')}
                      </span>
                    )}
                  </Typography>
                  {lengthCheck && (
                    <div
                      style={{
                        height: '20px',
                        width: '20px',
                        marginLeft: '10px',
                      }}
                      onClick={() =>
                        setOptionChainState({
                          holderModal: true,
                        })
                      }
                    >
                      <img height="100%" width="100%" src={SharkIcon} alt="" />
                    </div>
                  )}
                </div>
              </div>
            )}
          </Card>
          <SelectedExprationCard targetPriceChange={targetPriceChange} />
        </div>
      </div>
      {/* Select expiration div */}
      <SelectedExpration rows={rows} changeBidAskMid={changeBidAskMid} />
    </div>
  );
};

export default MobileView;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/MobileView.jsx